export default {
    required,
    minLength,
    mustMatch
};
// TODO: Validate field instanceof new form control

/********************************************************
 * @message: message to be displayed to the user
 * @field: sends full field for now, to get name and value
 *  might just be able to send the field it is applied to
 * ********************************************************/
export function required({ check = true, message = '' } = {}) {
    return function(field) {
        let error = { name: 'required', message: 'This is a Required Field' };
        let name = field.name;
        let value = field.value;
        let errors = field.errors || [];
        if ((!value && check == true) || (value.length <= 0 && check == true)) {
            if (message.length > 0) {
                error.message = message;
            }
            errors.push(error);
        }
        return errors;
    };
}

export function minLength({ length = 0, message = '' } = {}) {
    return function(field) {
        let error = {
            name: 'minlength',
            message: 'Please Enter a Minimum of ' + length + ' Characters'
        };
        let name = field.name;
        let value = field.value;
        let errors = field.errors;
        if (value.length < length) {
            if (message.lenth > 0) {
                error.message = message;
            }
            errors.push(error);
        }
        return errors;
    };
}
// TODO: Currently is set appended on created (will have to be on form level to capture both values)
export function mustMatch({ targetString, matcherString, message = '' } = {}) {
    // matcher is passed as a string and taken from the form group this is a formGroup level validator
    return function(formGroup) {
        let field = formGroup.formControl(targetString);
        let matcher = formGroup.formControl(matcherString);
        //matcher is the matcher value
        let error = { name: 'mustmatch', message: 'This field must match its matcher' };
        let name = field.name;
        let value = field.value;
        let errors = field.errors;
        let matcherValue = matcher.Value;
        if (matcherValue !== value) {
            if (message.length > 0) {
                error.message = message;
            }
            errors.push(error);
        }
        return errors;
    };
}

/**
 * Determines whether a given date and time fall outside of standard business hours.
 * Business hours are defined as 9:00 AM to 10:00 PM (inclusive).
 *
 * @param {string|Date|null} inputDate - The date to check. Can be a string, Date object, or null.
 * @returns {boolean} - Returns true if the time is outside business hours, otherwise false.
 */
export function isOffHours(inputDate) {
    let date = inputDate ?? null;

    if (!date) return false;

    date = new Date(date);
    const hours = date.getHours();
    const minutes = date.getMinutes();

    return (
        (hours > 22) ||
        (hours === 22 && minutes > 0) ||
        (hours < 9)
    );
}
